import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CssBaseline, Container, Typography, Box, Button, Chip, Checkbox, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab, TextField, Alert, CircularProgress, Skeleton, Menu, MenuItem, TablePagination } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import CustomizedSnackbars from '../../components/material-snackbars';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import AutoCompleteMultipleSelectSimple from '../../components/auto-complete/autocomplete-multiple-select-simple';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/header-menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import AddIcon from '@mui/icons-material/Add';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Api from '../../services/api';
import MarketingService, {
  normalizeList, normalizeListDetail, normalizeEligibleContact, normalizeContactRow, normalizeLocation,
} from '../../services/marketing.service';
import { getOrg } from '../../services/organization.service';
import moment from 'moment';
import { Overlay } from '../../styles/global';
import DialogConfirmation from '../../components/dialog-confirmation-not-button';

const fmtDate = (s) => (s ? moment(s).format('DD/MM/YYYY HH:mm') : '—');

const TYPE_META = {
  segment: { icon: <FilterAltOutlinedIcon sx={{ fontSize: 16 }} />, key: 'marketing.list.type.segment', color: '#277afe' },
  csv:     { icon: <UploadFileOutlinedIcon sx={{ fontSize: 16 }} />, key: 'marketing.list.type.csv', color: '#5b9b1e' },
  manual:  { icon: <TouchAppOutlinedIcon sx={{ fontSize: 16 }} />, key: 'marketing.list.type.manual', color: '#e67e22' },
};

// Serviços externos podem devolver array cru OU o corpo do CustomResponse ({ data: [...] }).
const asArray = (raw) => (Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : []));

class MarketingListManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      lists: [],
      tags: [], orgs: [], locations: [],
      dialogOpen: false,
      editingId: null,
      mode: 0, // 0 segment, 1 csv, 2 manual
      newName: '',
      saving: false,
      csvPreview: null, csvContacts: [], csvColumns: [],
      // segmentação multi-select (arrays de opções {id,name})
      segTags: [], segOrgs: [], segLocations: [],
      // seleção manual + cesta "add N"
      manualSearch: '', manualSearched: false, manualSearching: false, manualResults: [], manualSelected: [],
      // contato avulso (digitado na hora, sem estar na base)
      avulsoOpen: false, avulsoName: '', avulsoPhone: '55',
      // preview
      previewOpen: false, previewPage: 0, previewRpp: 10, segmentPreview: [],
      // menu de linha
      rowMenuAnchor: null, rowMenuItem: null,
      actionLoading: false,
      confirm: null, // { msg, onConfirm }
      notification: { open: false, variant: 'success', message: '' },
    };
    this.csvInputRef = React.createRef();
  }

  componentDidMount() { this.loadLists(); this.loadOptions(); }

  get lang() { return (window.location.pathname.split('/')[1]) || 'pt'; }
  // Volta pra lista de transmissões na aba de origem (?tab= recebido na navegação).
  backToBroadcasts = () => {
    const tab = new URLSearchParams(this.props.location ? this.props.location.search : '').get('tab');
    this.props.history.push(`/${this.lang}/marketing${tab ? `?tab=${tab}` : ''}`);
  };
  notify = (message, variant = 'success') => this.setState({ notification: { open: true, variant, message } });

  loadLists = () => {
    this.setState({ loading: true });
    MarketingService.listLists()
      .then(result => {
        const data = (result.data && result.data.success && Array.isArray(result.data.data))
          ? result.data.data.map(normalizeList) : [];
        this.setState({ lists: data, loading: false });
      })
      .catch(err => { this.setState({ loading: false }); Api.kickoff(err); });
  };

  loadOptions = async () => {
    try {
      const orgsRaw = await getOrg();
      const orgs = asArray(orgsRaw).map(o => ({ id: o.id, name: o.name }));
      // Tags: endpoint próprio do marketing que devolve {id,name} (tb_tags), não strings.
      const tagsRes = await MarketingService.getTags();
      const tags = (tagsRes.data && tagsRes.data.success && Array.isArray(tagsRes.data.data))
        ? tagsRes.data.data.map(t => ({ id: t.id, name: t.name })) : [];
      this.setState({ orgs, tags });
    } catch (err) { /* dropdowns vazios não quebram a página */ }
  };

  loadLocations = (orgIds, after) => {
    const ids = (orgIds || []).filter(Boolean);
    if (ids.length === 0) { this.setState({ locations: [] }, after); return; }
    MarketingService.getLocations(ids)
      .then(result => {
        const data = (result.data && result.data.success && Array.isArray(result.data.data))
          ? result.data.data.map(normalizeLocation) : [];
        this.setState({ locations: data }, after);
      })
      .catch(() => this.setState({ locations: [] }, after));
  };

  // Autocomplete padrão do projeto (filtra ao digitar), mantendo o state por id.
  acField = (label, options, valueId, onPick, extra = {}) => (
    <SimpleAutoComplete label={label} options={options} size="small" stateName="ac"
      selected={options.find(o => o.id === valueId) || { id: 0, name: '' }}
      changeSelect={(n, v) => onPick(v && v.id ? v.id : '')} {...extra} />
  );

  // Cesta "add N" da seleção manual: adiciona/remove contatos formando o pacote da lista.
  // Dedup por TELEFONE normalizado (não só por id): a tabela tem UNIQUE (marketing_list_id, phone),
  // então dois contatos com o mesmo número (avulso, busca ou base) estourariam no salvamento.
  normPhone = (p) => (p || '').replace(/\D/g, '');
  phoneInBasket = (phone) => { const d = this.normPhone(phone); return d !== '' && this.state.manualSelected.some(x => this.normPhone(x.phone) === d); };
  addManual = (c) => this.setState(p => {
    const d = this.normPhone(c.phone);
    const dup = p.manualSelected.some(x => x.id === c.id || (d !== '' && this.normPhone(x.phone) === d));
    return dup ? p : { manualSelected: [...p.manualSelected, c] };
  });
  removeManual = (id) => this.setState(p => ({ manualSelected: p.manualSelected.filter(x => x.id !== id) }));
  // "Adicionado" se já está na cesta por id OU pelo mesmo telefone.
  isManualAdded = (c) => { const d = this.normPhone(c.phone); return this.state.manualSelected.some(x => x.id === c.id || (d !== '' && this.normPhone(x.phone) === d)); };
  // Selecionar tudo / limpar: alterna entre adicionar todos os resultados e esvaziar a cesta.
  toggleAllManual = () => {
    const results = this.state.manualResults;
    const allAdded = results.length > 0 && results.every(c => this.isManualAdded(c));
    if (allAdded) {
      const resultIds = new Set(results.map(c => c.id));
      this.setState(p => ({ manualSelected: p.manualSelected.filter(x => !resultIds.has(x.id)) }));
    } else {
      this.setState(p => {
        const ids = new Set(p.manualSelected.map(x => x.id));
        const phones = new Set(p.manualSelected.map(x => this.normPhone(x.phone)).filter(Boolean));
        const toAdd = results.filter(c => !ids.has(c.id) && !phones.has(this.normPhone(c.phone)));
        return { manualSelected: [...p.manualSelected, ...toAdd] };
      });
    }
  };

  // Contato avulso (digitado na hora, sem estar na base). sourceType='avulso' → backend grava customer_id null.
  openAvulso = () => this.setState({ avulsoOpen: true, avulsoName: '', avulsoPhone: '55' });
  closeAvulso = () => this.setState({ avulsoOpen: false });
  avulsoValid = () => this.state.avulsoName.trim().length > 0 && this.normPhone(this.state.avulsoPhone).length >= 12;
  addAvulso = () => {
    const { intl } = this.props;
    const name = this.state.avulsoName.trim();
    const digits = this.normPhone(this.state.avulsoPhone);
    if (name.length === 0 || digits.length < 12) return;
    if (this.phoneInBasket(digits)) { this.notify(intl.formatMessage({ id: 'marketing.list.manual.adhoc.dup' }), 'error'); return; }
    const contact = { id: `avulso_${digits}`, sourceType: 'avulso', sourceId: null, name, phone: `+${digits}`, email: '', document: '' };
    this.setState(p => ({ manualSelected: [...p.manualSelected, contact], avulsoOpen: false }));
  };

  openNew = () => this.setState({ dialogOpen: true, editingId: null, mode: 0, newName: '', csvPreview: null, csvContacts: [], csvColumns: [], segTags: [], segOrgs: [], segLocations: [], locations: [], manualSearch: '', manualSearched: false, manualResults: [], manualSelected: [] });

  // Mapeia ids → opções {id,name} (usa as opções carregadas; fallback pro próprio id se ainda não veio).
  toOptions = (ids, pool) => (ids || []).map(id => (pool || []).find(o => o.id === id) || { id, name: String(id) });

  openEdit = (item) => {
    this.closeRowMenu();
    MarketingService.getList(item.id)
      .then(result => {
        if (!(result.data && result.data.success)) { this.notify(this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error'); return; }
        const d = normalizeListDetail(result.data.data);
        const mode = d.type === 'segment' ? 0 : d.type === 'csv' ? 1 : 2;
        const orgIds = d.criteria.organizationIds || [];
        this.setState({
          dialogOpen: true, editingId: d.id, mode, newName: d.name,
          segTags: this.toOptions(d.criteria.tags, this.state.tags),
          segOrgs: this.toOptions(orgIds, this.state.orgs),
          segLocations: [], locations: [],
          csvPreview: null, csvContacts: [], csvColumns: [], manualSearched: false, manualResults: [], manualSelected: [],
        });
        if (orgIds.length) this.loadLocations(orgIds, () => this.setState({ segLocations: this.toOptions(d.criteria.addressIds, this.state.locations) }));
        if (d.type === 'manual') this.loadManualBasket(d.id);
        if (d.type === 'csv') this.loadCsvForEdit(d.id);
      })
      .catch(err => Api.kickoff(err));
  };
  closeDialog = () => this.setState({ dialogOpen: false });

  // Edição CSV: carrega os contatos já salvos pro preview (mostra em tela o que foi upado).
  loadCsvForEdit = (listId) => {
    MarketingService.getListContactsForEdit(listId)
      .then(result => {
        const rows = (result.data && result.data.success && Array.isArray(result.data.data)) ? result.data.data : [];
        const contacts = rows.map(c => ({
          sourceType: c.sourcetype ?? c.sourceType ?? 'csv', sourceId: c.sourceid ?? c.sourceId ?? null,
          name: c.name, phone: c.phone, email: c.email, document: c.document,
        }));
        this.setState({ csvContacts: contacts, csvPreview: { rows: contacts.length, valid: contacts.length, invalid: 0, duplicates: 0 } });
      })
      .catch(err => Api.kickoff(err));
  };

  // Edição manual: carrega os contatos já salvos na cesta (reconstruídos do snapshot).
  loadManualBasket = (listId) => {
    MarketingService.getListContactsForEdit(listId)
      .then(result => {
        const items = (result.data && result.data.success && Array.isArray(result.data.data))
          ? result.data.data.map(c => {
              const sourceType = c.sourcetype ?? c.sourceType ?? 'manual';
              const sourceId = c.sourceid ?? c.sourceId ?? null;
              // Avulso (sem sourceId) usa o telefone como chave estável — evita ids colidindo em 'avulso_null'.
              const key = sourceId != null ? `${sourceType}_${sourceId}` : `${sourceType}_${this.normPhone(c.phone)}`;
              return { id: key, sourceType, sourceId, name: c.name, phone: c.phone, email: c.email, document: c.document };
            }) : [];
        this.setState({ manualSelected: items });
      })
      .catch(err => Api.kickoff(err));
  };

  // Edição CSV: baixa o .csv da lista já salva (formato de import).
  downloadListCsv = async () => {
    if (!this.state.editingId) return;
    try {
      const result = await MarketingService.exportListCsv(this.state.editingId);
      const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `marketing-lista-${this.state.editingId}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) { Api.kickoff(err); }
  };

  openRowMenu = (e, item) => this.setState({ rowMenuAnchor: e.currentTarget, rowMenuItem: item });
  closeRowMenu = () => this.setState({ rowMenuAnchor: null, rowMenuItem: null });

  // Excluir / duplicar pedem confirmação no modal padrão antes de chamar o backend.
  askDuplicateList = () => {
    const item = this.state.rowMenuItem; this.closeRowMenu();
    if (item) this.setState({ confirm: { msg: this.props.intl.formatMessage({ id: 'marketing.list.duplicate.confirm' }), onConfirm: () => this.doDuplicateList(item) } });
  };
  askDeleteList = () => {
    const item = this.state.rowMenuItem; this.closeRowMenu();
    if (item) this.setState({ confirm: { msg: this.props.intl.formatMessage({ id: 'marketing.list.delete.confirm' }), onConfirm: () => this.doDeleteList(item) } });
  };
  runConfirm = () => { const c = this.state.confirm; this.setState({ confirm: null }); if (c && c.onConfirm) c.onConfirm(); };

  doDuplicateList = async (item) => {
    this.setState({ actionLoading: true });
    try {
      const result = await MarketingService.duplicateList(item.id);
      if (result.data && result.data.success) { this.notify(this.props.intl.formatMessage({ id: 'marketing.list.duplicated' })); this.loadLists(); }
      else this.notify((result.data && result.data.errors && result.data.errors[0]) || this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    } catch (err) { Api.kickoff(err); }
    finally { this.setState({ actionLoading: false }); }
  };

  doDeleteList = async (item) => {
    this.setState({ actionLoading: true });
    try {
      const result = await MarketingService.deleteList(item.id);
      if (result.data && result.data.success) { this.notify(this.props.intl.formatMessage({ id: 'marketing.list.deleted' })); this.loadLists(); }
      else this.notify((result.data && result.data.errors && result.data.errors[0]) || this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    } catch (err) { Api.kickoff(err); }
    finally { this.setState({ actionLoading: false }); }
  };

  onCsvSelected = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    this.setState({ csvPreview: null });
    MarketingService.parseCsv(file)
      .then(result => {
        if (result.data && result.data.success) {
          const d = result.data.data;
          this.setState({
            csvPreview: { rows: d.total ?? 0, valid: d.valid ?? 0, invalid: d.invalid ?? 0, duplicates: 0 },
            csvContacts: (Array.isArray(d.contacts) ? d.contacts : []).map(c => ({
              sourceType: c.sourcetype ?? c.sourceType ?? 'csv',
              sourceId: c.sourceid ?? c.sourceId ?? null,
              name: c.name, phone: c.phone, email: c.email, document: c.document,
              extraFields: c.extrafields ?? c.extraFields ?? null,
            })),
            csvColumns: Array.isArray(d.columns) ? d.columns : [],
          });
        } else {
          this.notify((result.data && result.data.errors && result.data.errors[0]) || this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
        }
      })
      .catch(err => Api.kickoff(err));
    e.target.value = '';
  };

  runManualSearch = () => {
    this.setState({ manualSearching: true });
    MarketingService.searchContacts(this.currentCriteria(), this.state.manualSearch, 1, 50)
      .then(result => {
        const items = (result.data && result.data.success && result.data.data && Array.isArray(result.data.data.items))
          ? result.data.data.items.map(normalizeEligibleContact) : [];
        this.setState({ manualSearched: true, manualSearching: false, manualResults: items });
      })
      .catch(err => { this.setState({ manualSearching: false }); Api.kickoff(err); });
  };

  buildListModel = () => {
    const { mode } = this.state;
    const type = mode === 0 ? 'segment' : mode === 1 ? 'csv' : 'manual';
    if (type === 'segment') {
      return {
        name: this.state.newName.trim(), type,
        criteria: {
          tags: this.state.segTags.map(t => t.id),
          organizationIds: this.state.segOrgs.map(o => o.id),
          addressIds: this.state.segLocations.map(l => l.id),
        },
      };
    }
    const contacts = type === 'csv'
      ? this.state.csvContacts
      : this.state.manualSelected.map(c => ({ sourceType: c.sourceType, sourceId: c.sourceId, name: c.name, phone: c.phone, email: c.email, document: c.document }));
    return { name: this.state.newName.trim(), type, contacts };
  };

  saveList = async () => {
    const { editingId } = this.state;
    const model = this.buildListModel();
    this.setState({ saving: true });
    try {
      const result = editingId
        ? await MarketingService.updateList(editingId, model)
        : await MarketingService.createList(model);
      if (result.data && result.data.success) {
        this.notify(this.props.intl.formatMessage({ id: editingId ? 'marketing.list.updated' : 'marketing.list.saved' }));
        this.setState({ saving: false, dialogOpen: false });
        this.loadLists();
      } else {
        this.setState({ saving: false });
        this.notify((result.data && result.data.errors && result.data.errors[0]) || this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
      }
    } catch (err) {
      this.setState({ saving: false });
      Api.kickoff(err);
      this.notify(this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    }
  };

  renderEmpty() {
    const { intl } = this.props;
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: '#f5f5f5', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <ListAltOutlinedIcon sx={{ fontSize: 36, color: '#bdbdbd' }} />
        </Box>
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#555', mb: 0.5 }}>{intl.formatMessage({ id: 'marketing.list.empty.title' })}</Typography>
        <Typography sx={{ fontSize: 14, color: '#888', mb: 2 }}>{intl.formatMessage({ id: 'marketing.list.empty.desc' })}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={this.openNew}
          sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
          {intl.formatMessage({ id: 'marketing.list.new' })}
        </Button>
      </Box>
    );
  }

  renderListsTable() {
    const { intl } = this.props;
    const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, color: '#888', fontWeight: 600 };
    const td = { padding: '12px', fontSize: 13, color: '#333', borderTop: '1px solid #f0f0f0' };
    return (
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#fff' }}>
        <Box sx={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
            <thead><tr style={{ backgroundColor: '#fafafa' }}>
              <th style={th}>{intl.formatMessage({ id: 'marketing.list.col.name' })}</th>
              <th style={th}>{intl.formatMessage({ id: 'marketing.list.col.type' })}</th>
              <th style={th}>{intl.formatMessage({ id: 'marketing.list.col.contacts' })}</th>
              <th style={th}>{intl.formatMessage({ id: 'marketing.list.col.valid' })}</th>
              <th style={th}>{intl.formatMessage({ id: 'marketing.col.created' })}</th>
              <th style={{ ...th, width: 56, textAlign: 'right' }}></th>
            </tr></thead>
            <tbody>
              {this.state.lists.map(l => {
                const meta = TYPE_META[l.type] || TYPE_META.manual;
                return (
                  <tr key={l.id}>
                    <td style={td}><Typography sx={{ fontSize: 13, fontWeight: 600, color: '#277afe', cursor: 'pointer' }} onClick={() => this.openEdit(l)}>{l.name}</Typography></td>
                    <td style={td}><Chip size="small" icon={meta.icon} label={intl.formatMessage({ id: meta.key })} sx={{ borderRadius: '6px', backgroundColor: '#f4f4f4', color: meta.color, fontWeight: 600 }} /></td>
                    <td style={td}>{l.total.toLocaleString('pt-BR')}</td>
                    <td style={{ ...td, color: '#5b9b1e', fontWeight: 600 }}>{l.valid.toLocaleString('pt-BR')}</td>
                    <td style={td}>{fmtDate(l.createdAt)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>
                      <IconButton size="small" onClick={(e) => this.openRowMenu(e, l)}><MoreVertIcon fontSize="small" /></IconButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Box>
      </Box>
    );
  }

  // Conjunto que vai pro preview, por aba: segment = amostra da base (server); csv = parse; manual = cesta.
  previewContacts = () => {
    if (this.state.mode === 2) return this.state.manualSelected;
    if (this.state.mode === 1) return this.state.csvContacts;
    return this.state.segmentPreview;
  };

  openPreview = () => {
    if (this.state.mode === 0) {
      const criteria = {
        tags: this.state.segTags.map(t => t.id),
        organizationIds: this.state.segOrgs.map(o => o.id),
        addressIds: this.state.segLocations.map(l => l.id),
      };
      MarketingService.searchContacts(criteria, null, 1, 200)
        .then(result => {
          const items = (result.data && result.data.success && result.data.data && Array.isArray(result.data.data.items))
            ? result.data.data.items.map(normalizeEligibleContact) : [];
          this.setState({ segmentPreview: items, previewOpen: true, previewPage: 0 });
        })
        .catch(err => Api.kickoff(err));
    } else {
      this.setState({ previewOpen: true, previewPage: 0 });
    }
  };

  renderPreviewButton(enabled) {
    const { intl } = this.props;
    return (
      <Box>
        <Button variant="outlined" startIcon={<VisibilityOutlinedIcon />} disabled={!enabled}
          onClick={this.openPreview}
          sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
          {intl.formatMessage({ id: 'marketing.list.preview' })}
        </Button>
      </Box>
    );
  }

  // Filtros tags → organização → localização (multi-select). Reusados na segmentação E na busca manual.
  renderSegFilters() {
    const { intl } = this.props;
    return (
      <>
        <AutoCompleteMultipleSelectSimple label="Tags" options={this.state.tags} selected={this.state.segTags} limitTags={6}
          changeSelect={(v) => this.setState({ segTags: v || [] })} />
        <AutoCompleteMultipleSelectSimple label={intl.formatMessage({ id: 'organization' })} options={this.state.orgs} selected={this.state.segOrgs} limitTags={6}
          changeSelect={(v) => { const orgs = v || []; this.setState({ segOrgs: orgs, segLocations: [] }); this.loadLocations(orgs.map(o => o.id)); }} />
        {this.state.segOrgs.length > 0
          ? <AutoCompleteMultipleSelectSimple label={intl.formatMessage({ id: 'location' })} options={this.state.locations} selected={this.state.segLocations} limitTags={6}
              changeSelect={(v) => this.setState({ segLocations: v || [] })} />
          : <Typography sx={{ fontSize: 11, color: '#aaa', mt: -0.5 }}>{intl.formatMessage({ id: 'marketing.list.location.dep' })}</Typography>}
      </>
    );
  }

  // Critério atual (a partir dos filtros multi-select).
  currentCriteria = () => ({
    tags: this.state.segTags.map(t => t.id),
    organizationIds: this.state.segOrgs.map(o => o.id),
    addressIds: this.state.segLocations.map(l => l.id),
  });

  // Baixa a base segmentada em CSV (mesmo critério do preview) no formato que a aba CSV importa.
  downloadSegmentCsv = async () => {
    try {
      const result = await MarketingService.downloadSegmentCsv(this.currentCriteria());
      const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'marketing-segmentacao.csv';
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) { Api.kickoff(err); }
  };

  renderSegment() {
    const { intl } = this.props;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography sx={{ fontSize: 13, color: '#888' }}>{intl.formatMessage({ id: 'marketing.list.segment.note' })}</Typography>
        {/* Ordem: Tags → Organização → Localização (esta depende da org) — multi-select */}
        {this.renderSegFilters()}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {this.renderPreviewButton(true)}
          <Button variant="outlined" startIcon={<FileDownloadOutlinedIcon />} onClick={this.downloadSegmentCsv}
            sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
            {intl.formatMessage({ id: 'marketing.list.downloadCsv' })}
          </Button>
        </Box>
      </Box>
    );
  }

  renderCsv() {
    const { intl } = this.props;
    const { csvPreview } = this.state;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <input ref={this.csvInputRef} type="file" accept=".csv,text/csv" style={{ display: 'none' }} onChange={this.onCsvSelected} />
        <Box sx={{ border: '2px dashed #cfcfcf', borderRadius: '10px', p: 3, textAlign: 'center', cursor: 'pointer' }} onClick={() => this.csvInputRef.current && this.csvInputRef.current.click()}>
          <UploadFileOutlinedIcon sx={{ fontSize: 36, color: '#bdbdbd' }} />
          <Typography sx={{ fontSize: 13, color: '#888', mt: 1 }}>{intl.formatMessage({ id: 'marketing.list.csv.drop' })}</Typography>
          <Typography sx={{ fontSize: 11, color: '#aaa' }}>{intl.formatMessage({ id: 'marketing.list.csv.format' })}</Typography>
        </Box>
        {csvPreview && (
          <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
            {[['rows', csvPreview.rows, '#333'], ['valid', csvPreview.valid, '#5b9b1e'], ['invalid', csvPreview.invalid, '#c0392b'], ['duplicates', csvPreview.duplicates, '#e67e22']].map(([k, val, color]) => (
              <Box key={k} sx={{ flex: 1, minWidth: 90, border: '1px solid #e0e0e0', borderRadius: '8px', p: 1 }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, color }}>{val}</Typography>
                <Typography sx={{ fontSize: 11, color: '#888' }}>{intl.formatMessage({ id: `marketing.list.csv.${k}` })}</Typography>
              </Box>
            ))}
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          {/* Pré-visualizar mostra o que foi upado/salvo; na edição também aparece o download do .csv salvo */}
          {this.renderPreviewButton(!!csvPreview || this.state.csvContacts.length > 0)}
          {this.state.editingId && (
            <Button variant="outlined" startIcon={<FileDownloadOutlinedIcon />} onClick={this.downloadListCsv}
              sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
              {intl.formatMessage({ id: 'marketing.list.downloadSaved' })}
            </Button>
          )}
        </Box>
      </Box>
    );
  }

  renderManual() {
    const { intl } = this.props;
    const { manualSelected, manualResults } = this.state;
    const allAdded = manualResults.length > 0 && manualResults.every(c => this.isManualAdded(c));
    const someAdded = manualSelected.length > 0;
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, minHeight: 0 }}>
        {/* Campo aberto (nome/telefone) é o PRIMEIRO; filtros tags/org/localização vêm abaixo p/ refinar */}
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <TextField fullWidth size="small" InputLabelProps={{ shrink: true }} label={intl.formatMessage({ id: 'marketing.list.manual.search' })}
            placeholder="Nome ou telefone..." value={this.state.manualSearch} onChange={e => this.setState({ manualSearch: e.target.value })} />
          <Button variant="contained" startIcon={<SearchIcon />} onClick={this.runManualSearch} disabled={this.state.manualSearching}
            sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' }, whiteSpace: 'nowrap' }}>
            {intl.formatMessage({ id: 'search' })}
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Typography sx={{ fontSize: 12, color: '#888' }}>{intl.formatMessage({ id: 'marketing.list.manual.filters' })}</Typography>
          <Button size="small" variant="outlined" startIcon={<PersonAddAlt1OutlinedIcon />} onClick={this.openAvulso}
            sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444', whiteSpace: 'nowrap' }}>
            {intl.formatMessage({ id: 'marketing.list.manual.addAdhoc' })}
          </Button>
        </Box>
        {this.renderSegFilters()}

        {/* Scroll único é o do div externo do DialogContent (regra CLAUDE.md): aqui NÃO cappamos
            altura nem damos overflow próprio — resultados e cesta fluem no scroll de cima. */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {/* Resultados da busca (2 colunas completas: nome + telefone) com "Adicionar" */}
          {this.state.manualSearched && manualResults.length === 0 && (
            <Box sx={{ border: '1px dashed #e0e0e0', borderRadius: '8px', p: 3, textAlign: 'center', backgroundColor: '#fafafa', flexShrink: 0 }}>
              <SearchOffOutlinedIcon sx={{ fontSize: 36, color: '#bdbdbd', mb: 0.5 }} />
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#666' }}>{intl.formatMessage({ id: 'marketing.list.manual.empty.title' })}</Typography>
              <Typography sx={{ fontSize: 12, color: '#999' }}>{intl.formatMessage({ id: 'marketing.list.manual.empty.desc' })}</Typography>
            </Box>
          )}
          {this.state.manualSearched && manualResults.length > 0 && (
            <Box sx={{ border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr style={{ backgroundColor: '#fafafa', position: 'sticky', top: 0, zIndex: 1 }}>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.list.col.name' })}</th>
                  <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.col.sender' })}</th>
                  <th style={{ width: 120, textAlign: 'right', padding: '2px 8px', backgroundColor: '#fafafa' }}>
                    <Tooltip title={intl.formatMessage({ id: allAdded ? 'marketing.list.manual.clearAll' : 'marketing.list.manual.selectAll' })} arrow>
                      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }} onClick={this.toggleAllManual}>
                        <Checkbox size="small" checked={allAdded} indeterminate={someAdded && !allAdded} />
                        <Typography sx={{ fontSize: 11, color: '#666', fontWeight: 600 }}>{intl.formatMessage({ id: 'marketing.list.manual.all' })}</Typography>
                      </Box>
                    </Tooltip>
                  </th>
                </tr></thead>
                <tbody>
                  {manualResults.map(c => {
                    const added = this.isManualAdded(c);
                    return (
                      <tr key={c.id}>
                        <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5' }}>{c.name}</td>
                        <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5', whiteSpace: 'nowrap' }}>{c.phone}</td>
                        <td style={{ padding: '8px 12px', borderTop: '1px solid #f5f5f5', textAlign: 'right' }}>
                          <Button size="small" disabled={added} startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => this.addManual(c)}
                            sx={{ textTransform: 'none', minWidth: 0, color: added ? '#aaa' : '#5b9b1e' }}>
                            {intl.formatMessage({ id: added ? 'marketing.list.manual.added' : 'add' })}
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Box>
          )}

          {/* Cesta: contatos selecionados (visíveis, com remover) — fixa no rodapé da região, sempre visível */}
          <Box sx={{ border: '1px solid #cfe8bf', borderRadius: '8px', p: 1.5, backgroundColor: '#f6fbef', flexShrink: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: manualSelected.length ? 1 : 0 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#5b9b1e' }}>
                {intl.formatMessage({ id: 'marketing.list.manual.basket' })} ({manualSelected.length})
              </Typography>
              {manualSelected.length > 0 && this.renderPreviewButton(true)}
            </Box>
            {manualSelected.length === 0
              ? <Typography sx={{ fontSize: 12, color: '#90a4ae' }}>{intl.formatMessage({ id: 'marketing.list.manual.basketEmpty' })}</Typography>
              : (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8, maxHeight: 150, overflowY: 'auto' }}>
                  {manualSelected.map(c => (
                    <Chip key={c.id} size="small" onDelete={() => this.removeManual(c.id)} label={`${c.name} · ${c.phone}`}
                      sx={{ borderRadius: '6px', backgroundColor: '#fff', border: '1px solid #cfe8bf' }} />
                  ))}
                </Box>
              )}
          </Box>
        </Box>

        <Alert severity="info">{intl.formatMessage({ id: 'marketing.list.manual.note' })}</Alert>
        {this.renderAvulsoDialog()}
      </Box>
    );
  }

  // Modal de contato avulso: nome + telefone (DDI/DDD via PhoneInput, default Brasil) com validação.
  renderAvulsoDialog() {
    const { intl } = this.props;
    const valid = this.avulsoValid();
    return (
      <Dialog open={this.state.avulsoOpen} onClose={this.closeAvulso} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
        <DialogTitle sx={{ fontSize: 16, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
          <PersonAddAlt1OutlinedIcon sx={{ color: '#5b9b1e' }} />
          {intl.formatMessage({ id: 'marketing.list.manual.adhoc.title' })}
        </DialogTitle>
        <DialogContent dividers>
          <TextField fullWidth size="small" InputLabelProps={{ shrink: true }} autoFocus sx={{ mb: 2 }}
            label={intl.formatMessage({ id: 'marketing.list.manual.adhoc.name' })} value={this.state.avulsoName}
            onChange={e => this.setState({ avulsoName: e.target.value })} />
          <Typography sx={{ fontSize: 12, color: '#888', mb: 0.5 }}>{intl.formatMessage({ id: 'marketing.list.manual.adhoc.phone' })}</Typography>
          <PhoneInput
            country="br"
            value={this.state.avulsoPhone}
            onChange={(value) => this.setState({ avulsoPhone: value })}
            countryCodeEditable
            enableSearch
            disableSearchIcon
            inputStyle={{ height: 42, width: '100%', fontSize: 14, paddingLeft: 52 }}
            buttonStyle={{ height: 42, borderTopLeftRadius: 4, borderBottomLeftRadius: 4 }}
            specialLabel=""
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={this.closeAvulso} sx={{ textTransform: 'none', color: '#666' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={this.addAvulso} disabled={!valid}
            sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
            {intl.formatMessage({ id: 'add' })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDialog() {
    const { intl } = this.props;
    const { mode, editingId } = this.state;
    return (
      <Dialog open={this.state.dialogOpen} onClose={(e, reason) => { if (reason !== 'backdropClick') this.closeDialog(); }} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '12px', maxHeight: '90vh' } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>{intl.formatMessage({ id: editingId ? 'marketing.list.edit' : 'marketing.list.new' })}</DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          {/* Div puro + style inline = container de rolagem único e confiável (regra CLAUDE.md:
              o flex do DialogContent ignora overflowY/maxHeight via sx e corta o conteúdo). */}
          <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '16px 20px' }}>
            <TextField fullWidth size="small" InputLabelProps={{ shrink: true }} sx={{ mb: 2 }}
              label={intl.formatMessage({ id: 'marketing.list.name' })} value={this.state.newName} onChange={e => this.setState({ newName: e.target.value })} />
            {/* Trocar de aba NÃO apaga o preenchimento — cada aba mantém seu estado; Salvar usa a aba ativa (mode).
                Na EDIÇÃO, o tipo é fixo: as abas que não são do tipo da lista ficam desabilitadas. */}
            <Tabs value={mode} onChange={(_e, m) => this.setState({ mode: m })} sx={{ mb: 2, '& .MuiTabs-indicator': { backgroundColor: '#8BC34A' } }}>
              <Tab disabled={!!editingId && mode !== 0} icon={<FilterAltOutlinedIcon />} iconPosition="start" label={intl.formatMessage({ id: 'marketing.list.type.segment' })} sx={{ textTransform: 'none', minHeight: 48 }} />
              <Tab disabled={!!editingId && mode !== 1} icon={<UploadFileOutlinedIcon />} iconPosition="start" label={intl.formatMessage({ id: 'marketing.list.type.csv' })} sx={{ textTransform: 'none', minHeight: 48 }} />
              <Tab disabled={!!editingId && mode !== 2} icon={<TouchAppOutlinedIcon />} iconPosition="start" label={intl.formatMessage({ id: 'marketing.list.type.manual' })} sx={{ textTransform: 'none', minHeight: 48 }} />
            </Tabs>
            {mode === 0 && this.renderSegment()}
            {mode === 1 && this.renderCsv()}
            {mode === 2 && this.renderManual()}
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={this.closeDialog} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button variant="contained" onClick={this.saveList} disabled={!this.state.newName.trim() || this.state.saving}
            startIcon={this.state.saving ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
            {intl.formatMessage({ id: 'save' })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderPreviewDialog() {
    const { intl } = this.props;
    const { previewPage, previewRpp } = this.state;
    const all = this.previewContacts() || [];
    // Garante que a página atual é válida mesmo se o conjunto mudar de tamanho.
    const maxPage = Math.max(0, Math.ceil(all.length / previewRpp) - 1);
    const page = Math.min(previewPage, maxPage);
    const slice = all.slice(page * previewRpp, page * previewRpp + previewRpp);
    return (
      <Dialog open={this.state.previewOpen} onClose={() => this.setState({ previewOpen: false })} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px', maxHeight: '85vh' } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>
          {intl.formatMessage({ id: 'marketing.list.preview.title' })}
          <Typography sx={{ fontSize: 12, color: '#888', fontWeight: 400 }}>{all.length} {intl.formatMessage({ id: 'marketing.list.preview.count' })}</Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <Box sx={{ maxHeight: '55vh', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ backgroundColor: '#fafafa', position: 'sticky', top: 0 }}>
                <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.list.col.name' })}</th>
                <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, color: '#888', fontWeight: 600, backgroundColor: '#fafafa' }}>{intl.formatMessage({ id: 'marketing.col.sender' })}</th>
              </tr></thead>
              <tbody>
                {slice.map((c, i) => (
                  <tr key={c.id != null ? c.id : (page * previewRpp + i)}>
                    <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5' }}>{c.name}</td>
                    <td style={{ padding: '8px 12px', fontSize: 13, borderTop: '1px solid #f5f5f5', whiteSpace: 'nowrap' }}>{c.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
          <TablePagination component="div" count={all.length} page={page} rowsPerPage={previewRpp}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageChange={(_e, p) => this.setState({ previewPage: p })}
            onRowsPerPageChange={(e) => this.setState({ previewRpp: parseInt(e.target.value, 10), previewPage: 0 })}
            labelRowsPerPage={intl.formatMessage({ id: 'marketing.list.preview.perPage' })}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => this.setState({ previewOpen: false })} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'close' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const { loading, notification } = this.state;
    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={this.backToBroadcasts} sx={{ textTransform: 'none', color: '#666' }}>{intl.formatMessage({ id: 'marketing.back.list' })}</Button>
                <ListAltOutlinedIcon sx={{ color: '#5b9b1e' }} />
                <Typography sx={{ fontSize: 20, fontWeight: 700, color: '#333' }}>{intl.formatMessage({ id: 'marketing.lists.title' })}</Typography>
              </Box>
              <Button variant="contained" startIcon={<AddIcon />} onClick={this.openNew}
                sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
                {intl.formatMessage({ id: 'marketing.list.new' })}
              </Button>
            </Box>

            {loading
              ? <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fff' }}>{[...Array(3)].map((_, i) => <Skeleton key={i} variant="text" height={40} animation="wave" />)}</Box>
              : (this.state.lists.length > 0 ? this.renderListsTable() : this.renderEmpty())}

            <Menu anchorEl={this.state.rowMenuAnchor} open={Boolean(this.state.rowMenuAnchor)} onClose={this.closeRowMenu}>
              <MenuItem onClick={() => this.openEdit(this.state.rowMenuItem)} sx={{ fontSize: 13, gap: 1 }}><EditOutlinedIcon fontSize="small" /> {intl.formatMessage({ id: 'edit' })}</MenuItem>
              <MenuItem onClick={this.askDuplicateList} sx={{ fontSize: 13, gap: 1 }}><ContentCopyOutlinedIcon fontSize="small" /> {intl.formatMessage({ id: 'marketing.action.duplicate' })}</MenuItem>
              <MenuItem onClick={this.askDeleteList} sx={{ fontSize: 13, gap: 1, color: '#c0392b' }}><DeleteOutlineIcon fontSize="small" /> {intl.formatMessage({ id: 'delete' })}</MenuItem>
            </Menu>
          </Container>
          <Footer />
        </main>
        {this.renderDialog()}
        {this.renderPreviewDialog()}
        {this.state.confirm && (
          <DialogConfirmation
            msg={intl.formatMessage({ id: 'marketing.confirm.title' })}
            optionToDelete={<span style={{ fontSize: '0.95rem', fontWeight: 400, color: '#444' }}>{this.state.confirm.msg}</span>}
            msgAgree={intl.formatMessage({ id: 'yes' })}
            msgDisagree={intl.formatMessage({ id: 'no' })}
            handleClose={() => this.setState({ confirm: null })}
            handleConfirmation={this.runConfirm}
          />
        )}
        {this.state.actionLoading && (
          <Overlay>
            <CircularProgress color="primary" />
          </Overlay>
        )}
        <CustomizedSnackbars variant={notification.variant} message={notification.message} isOpen={notification.open}
          toClose={() => this.setState({ notification: { ...notification, open: false } })} />
      </div>
    );
  }
}

const mapStateToProps = state => ({ headerMenu: state.headerMenu, actionsHeaderMenu: state.actionsHeaderMenu, userSession: state.userSession });
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MarketingListManagement)));
